<template>
    <main class="pd-main">
        <div class="main-content">
            <header class="header no-border">
                <div class="header-bar">
                <h4 class="text-uppercase">Dashboard</h4>
                </div>
            </header>
             <div class="card card-body no-border py-30">
                    <strong>ATTENTION: Always ensure to logout from your listener account whenever you leave Fitila. You don't want to leave members who need your help hanging!</strong>
                </div>
            <circle-spin class=" m-0" v-if="loading"></circle-spin>
            <div class="row" v-else>
                <div class="col-xl-3 col-md-4">
                    <router-link tag="a" to="/listener/certifications">
                    <div class="card card-body">
                    <h6 class="text-uppercase">Completed Trainings</h6>
                    <div class="flexbox mt-2">
                        <span class="ion-ios-book text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{completed_training}}</h6>
                    </div>
                    </div> 
                    </router-link>
                </div>
                <div class="col-xl-3 col-md-4">
                    <div class="card card-body">
                    <h6 class="text-uppercase">All Chats</h6>
                    <div class="flexbox mt-2">
                        <span class="ion-chatboxes text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{chats}}</h6>
                    </div>
                    </div>
                </div>
                <div class="col-xl-3 col-md-4">
                    <div class="card card-body">
                    <h6 class="text-uppercase">Average Overall Rating</h6>
                    <div class="flexbox mt-2">
                        <span class="ion-star text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{Math.floor(rating)}}/10</h6>
                    </div>
                    </div>
                </div>
            </div>
            
        </div>
    </main>
</template>


<script>
import axios from 'axios'
import allMixins from '../../mixins.js'

export default {
    name: 'dashboardListener',
    mixins: [allMixins],
    data() {
        return {
            loading: false,
            completed_training: 0,
            rating: 0,
            chats: 0,
        }
    },
   mounted() {
        this.loading = true
        let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")

        axios.get(`users/find/${details.id}`)
        .then(res => {
            // console.log(res)
            let listener_id = res.data.listener[0].id
            let total = 0
            if(res.data.listener[0].ratings.length < 1){
                this.rating = 0
            }
            else{
                for(let i=0; i < res.data.listener[0].ratings.length; i++) {
                    total = total + res.data.listener[0].ratings[i].score
                }
                this.rating = total/res.data.listener[0].ratings.length
            }  
            // get all overall number of chats
            axios.get(`/users/discussion/all/user/?m=listener&listenerId=${listener_id}`)
            .then(res => {
                // console.log(res)
                this.chats = res.data.totalCount
                // get all trainings completed by listener
                axios.get(`/admin/training/complete?listenerId=${listener_id}`)
                    .then(res => {
                        this.loading = false
                            if(res.data.data[0].trainings.length > 0){
                                this.completed_training = res.data.data[0].trainings.length
                            }
                            else this.completed_training = 0
                    })
                    .catch(err => {
                        this.loading = false
                        // console.log(err)
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000
                        })
                    })
            })
            .catch(err => {
                this.loading = false
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000
                        })
            })
        })
        .catch(err => {
            this.loading = false
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000
                        })
        })
   }
}
</script>
